import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageview, trackGA } from '../../lib/analytics';

/**
 * Componente para rastrear automaticamente pageviews no GA4
 * Coloque este componente no App.tsx ou no Layout
 */
export function TrackPageView() {
  const location = useLocation();

  useEffect(() => {
    // Rastreia pageview quando a rota muda
    pageview(location.pathname + location.search, document.title);
    
    // Rastreia eventos específicos baseados na rota
    if (location.pathname === '/') {
      trackGA.homeView();
    } else if (location.pathname === '/buscar') {
      const searchParams = new URLSearchParams(location.search);
      const filters = searchParams.toString();
      trackGA.resultsView(filters || undefined);
    }
  }, [location]);

  return null;
}

/**
 * Hook para rastrear pageview manualmente
 * Útil para páginas com dados dinâmicos
 */
// eslint-disable-next-line react-refresh/only-export-components
export function useTrackPageView(path: string, title?: string) {
  useEffect(() => {
    pageview(path, title);
  }, [path, title]);
}
